export default __webpack_public_path__ + "static/media/entenda_c_grupado.f79cb01a.jpg";